import { Info } from '@phosphor-icons/react';
import { Brokerages } from '../../components/Brokerages/intex';
import {
  ActionActiveContainer,
  ContentItemsFilterColumnTable,
  ContentTable,
  FooterTable,
} from './styles';
import { useEffect, useMemo, useState } from 'react';
import { ModalDesigner } from '../../../../../components/ModalDesigner';
import { FormCreateRule } from '../../../../components/Boltz/MyWallet/FormCreateRule';
import { useActivesWallet } from '../../hooks/ActivesHooks';
import { transformMaskCurrency } from '../../../../../utils/transformMaskCurrency';
import { useActives } from '../../../../../hooks/useActives';
import { AllTable } from '../AllActive/components/AllTable';
import { InternationalTradeManager } from '../../../../../components/Forms/InternationalTradeManager';
import { EditColumnsButton } from '../../../../../components/EditColumnsButton';

const REITS_TYPES = ['reit', 'reits'];

export function ReitsActives() {
  const { fullWallet, updateWallet, setFullWallet } = useActivesWallet();
  // @ts-ignore
  const { showActive } = useActives();

  let filterTable = localStorage.getItem('filterTableReits-v1.0.0');
  // @ts-ignore
  filterTable = JSON.parse(filterTable);

  const [selectedBrokerage, setSelectedBrokerage] = useState('');
  const [rule, setRule] = useState(false);
  const [showModalCreateRule, setShowModalCreateRule] = useState(false);
  const [showModalSelectedDateTable, setShowModalSelectedDateTable] =
    useState(false);
  const [filterTextSearchActive, setFilterTextSearchActive] = useState('');
  const [operateAsset, setOperateAsset] = useState<any>(null);

  const [filterShowColumnTable, setFilterShowColumnTable] = useState<string[]>(
    () => {
      if (filterTable === null) {
        return ['Ativo', 'Cotação', 'Nota', 'Quant.', 'Objetivo'];
      } else {
        return filterTable as unknown as string[];
      }
    }
  );

  const arrColumnTableData = [
    'Ativo',
    'Nota',
    'Cotação',
    'Quant.',
    'Patrimônio',
    'Atual',
    'Diferença',
    'Preço médio',
    'Preço médio com proventos',
    'Total de proventos recebidos',
    'Total investido',
    'Rentabilidade com proventos',
    'Lucro/Prejuízo',
  ];

  const arrColumnTableRecommended = [
    'Ativo',
    'Cotação',
    'Nota',
    'Quant.',
    'Objetivo',
  ];

  useEffect(() => {
    localStorage.setItem(
      'filterTableReits-v1.0.0',
      JSON.stringify(filterShowColumnTable)
    );
  }, [filterShowColumnTable]);

  function handleSelectedColumnTable(value: string) {
    const isValueAllReadyExist = filterShowColumnTable.find(
      (item: string) => item === value
    );

    if (isValueAllReadyExist) {
      setFilterShowColumnTable((state: string[]) => {
        return state.filter((item: string) => item !== value);
      });
    } else {
      setFilterShowColumnTable((state: string[]) => {
        return [...state, value];
      });
    }
  }

  const reitsList = useMemo(
    () =>
      (fullWallet?.positionsAll ?? []).filter((item: any) =>
        REITS_TYPES.includes(item?.productTypeName)
      ),
    [fullWallet]
  );

  const reitsWallet = useMemo(
    () => ({ ...fullWallet, positionsAll: reitsList }),
    [fullWallet, reitsList]
  );

  const totalReitsMoney = reitsList.reduce(
    (acc: number, item: any) =>
      acc +
      (Number(item?.updateValue) ||
        Number(item?.closingPrice ?? 0) * Number(item?.equitiesQuantity ?? 0)),
    0
  );

  const amountActives = reitsList.length;

  return (
    <ActionActiveContainer>
      {window.screen.width > 768 && <Brokerages />}

      <ContentTable>
        <header>
          <span>Meus ativos</span>
          <EditColumnsButton
            label="Adicionar campos"
            onClick={() => setShowModalSelectedDateTable(true)}
          />
        </header>

        <AllTable
          //@ts-ignore
          fullWallet={reitsWallet}
          handleOrientationTable={setFullWallet}
          setRule={setRule}
          selectedBrokerage={selectedBrokerage}
          setShowModalCreateRule={setShowModalCreateRule}
          filterShowColumnTable={filterShowColumnTable as string[]}
          filterTextSearchActive={filterTextSearchActive}
          onOperateAsset={(item: any) => setOperateAsset(item)}
        />

        <FooterTable>
          <p>
            Total:{' '}
            <strong>
              {showActive
                ? transformMaskCurrency(totalReitsMoney)
                : 'R$ ******'}
            </strong>
          </p>
          <p>
            Total de ativos: <strong>{amountActives}</strong>
          </p>
          <p>
            Porcentagem total: <strong>100%</strong>
          </p>
        </FooterTable>
      </ContentTable>

      <ModalDesigner
        id="selecionarColunasReits"
        isOpen={showModalSelectedDateTable}
        setState={setShowModalSelectedDateTable}
        title="Adicionar campos"
        size="sm"
      >
        <ContentItemsFilterColumnTable>
          <span className="recommendText">Recomendado</span>

          <div className="contentInput">
            {arrColumnTableRecommended.map((item) => (
              <label key={item}>
                <input
                  type="checkbox"
                  value={item}
                  defaultChecked={filterShowColumnTable.includes(item)}
                  onChange={(e) => handleSelectedColumnTable(e.target.value)}
                />
                {item}
              </label>
            ))}
          </div>

          <span className="addMore">CAMPOS ADICIONAIS</span>

          <div className="contentInput">
            {arrColumnTableData
              .filter(
                (item) =>
                  item !== 'Ativo' &&
                  item !== 'Cotação' &&
                  item !== 'Nota' &&
                  item !== 'Quant.'
              )
              .map((item) => (
                <label key={item}>
                  <input
                    type="checkbox"
                    value={item}
                    defaultChecked={filterShowColumnTable.includes(item)}
                    onChange={(e) => handleSelectedColumnTable(e.target.value)}
                  />
                  {item}
                </label>
              ))}
          </div>

          <span className="important">
            <Info size={16} color="#505050" weight="bold" /> IMPORTANTE
          </span>

          <p className="warning">
            Alterar a estrutura da tabela de ativos padrão pode afetar sua
            experiência, recomendamos que sempre que possível, utilize a tabela
            padrão.
          </p>
        </ContentItemsFilterColumnTable>
      </ModalDesigner>

      {showModalCreateRule && (
        <FormCreateRule
          //@ts-ignore
          rule={rule}
          setShowModalCreateRule={setShowModalCreateRule}
          showModalCreateRule={showModalCreateRule}
          update={() => updateWallet()}
        />
      )}

      <ModalDesigner
        id="reitTradeManager"
        isOpen={!!operateAsset}
        setState={() => setOperateAsset(null)}
        title={`Operações — ${operateAsset?.tickerSymbol ?? ''}`}
        size="md"
      >
        {operateAsset && (
          <InternationalTradeManager
            active={operateAsset}
            onClose={() => setOperateAsset(null)}
          />
        )}
      </ModalDesigner>
    </ActionActiveContainer>
  );
}
